export const SUPPORTED_LANGUAGES = ['en', 'fr', 'es', 'de', 'it', 'pt', 'ru'];
export const DEFAULT_LANGUAGE = 'en';